

import IROUTER from './ABI/IROUTER.json'
import IToken from './ABI/IToken.json'
import {
    ChainName,
    ChainCoinName,
    BALANCE_LIST,
    PRICE_LIST,
    STABLE_COIN_LIST,
    ROUTER,
    MultiCallAddress
} from './contract'

import {
    OnBlock,
    WeiToUnits,
    EtherToWei,
    Erc20,
    MultiCall,
    CreateProviderForRpc,
    GetGlobalSigner,
    CreateContract,
    DEFAULT_ACCOUNT,
    BN,
    // SignApproves,
    SwitchChain,
    Approves,
    BigToString,
    ZERO_ADDRESS
} from '../ethers/e'

function Erc20Wrap(address) {
    return CreateContract(address, IToken, GetGlobalSigner())
}

function Multi() {
    return MultiCall(MultiCallAddress, GetGlobalSigner())
}

function Router() {
    return CreateContract(ROUTER, IROUTER, GetGlobalSigner())
}


const BALANCE_TYPE = {
    tokens: {
        [ChainName]: [ZERO_ADDRESS, 18, ChainName, ChainCoinName]
    },
    balances: {},
    prices: {},
    totalValue: 0
}
BALANCE_LIST.forEach(v => {
    BALANCE_TYPE.balances[v[2]] = 0
    BALANCE_TYPE.tokens[v[2]] = v
})
PRICE_LIST.forEach(v => {
    const [token0] = v
    const key = token0[2]
    BALANCE_TYPE.prices[key] = 0
})

export async function Balance(address) {
    
    const router = Router()
    let prices = {}
    

    PRICE_LIST.forEach(v => {
        const [token0] = v
        const key = token0[2]

        const e18 = BN(10).pow(token0[1])
        prices[key] = router.calls.getAmountsOut(
            e18,
            v.map(v => v[0])
        )
    })

    const tokens = BALANCE_LIST.map(v => {
        const contract = Erc20Wrap(v[0])
        contract._token = v
        return contract
    })
    const mul = Multi()
    const results = await mul.all({
        tokens: tokens.map(v => {
                return v.calls.balanceOf(address)
            }),
        [ChainName]: mul.$.calls.getEthBalance(address),
        prices
    })

    for(let k in results.prices) {
        const price = results.prices[k]
        prices[k] = price[price.length - 1].toString() / price[0].toString()
    }
    // stable coin
    STABLE_COIN_LIST.forEach(v => {
        const [token, price] = v
        const key = token[2]
        prices[key] = price
    })

    const balances = {
        [ChainName]: WeiToUnits(results[ChainName])
    }

    results.tokens.forEach((v,i) => {
        const [, decimal,name] = BALANCE_LIST[i]
        balances[name] = WeiToUnits(v, decimal)
    })
    
    let totalValue = 0
    Object.keys(prices).forEach(coin => {
        totalValue += prices[coin] * (balances[coin] || 0)
    })

    // totalValue += balances.USDT*1 || 0
    // console.log(totalValue, " totalValue")
    return {totalValue, balances, prices, tokens: BALANCE_TYPE.tokens}
}

Balance.Type = BALANCE_TYPE

